import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { bindActionCreators } from 'redux'
import * as lmExpressActions from 'action/lmexpress'
import * as reportActions from 'action/report'
import ContentHeader from 'component/utils/ContentHeader'
import LmExpress from 'component/report/lmexpress/OlderLmExpress'
import LmExpressHeader from 'component/report/lmexpress/LmExpressHeader'
import PeriodPickerLmExpress from 'component/report/lmexpress/PeriodPickerLmExpress'
import FeedbackError from 'component/utils/FeedbackError'

class OlderLmExpressContainer extends Component {
  static propTypes = {
    translate: PropTypes.func.isRequired,
    fetchLmExpress: PropTypes.func.isRequired,
    fetchReports: PropTypes.func.isRequired,
    error: PropTypes.object,
    lmExpress: PropTypes.object,
    filters: PropTypes.object,
    auth: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props)

    this.state = {
      filtersVisible: true,
      lmExpressInfoVisible: false,
      controlView: false,
    }

    this.getCsv = this.getCsv.bind(this)
    this.invertStates = this.invertStates.bind(this)
    this.handleFetchLmExpress = this.handleFetchLmExpress.bind(this)
  }

  componentWillReceiveProps() {
    const { filtersVisible, controlView } = this.state
    const { lmExpress } = this.props
    /* istanbul ignore else */
    if (filtersVisible && lmExpress && controlView) {
      this.invertStates()
    }
  }

  getCsv() {
    const {
      fetchReports,
      filters,
      auth: { user },
    } = this.props

    const values = {
      tpReport: 5,
    }

    fetchReports(user.dsToken, values, filters)
  }

  invertStates() {
    let { filtersVisible, lmExpressInfoVisible } = this.state

    filtersVisible = !filtersVisible
    lmExpressInfoVisible = !lmExpressInfoVisible

    this.setState({ filtersVisible })
    this.setState({ lmExpressInfoVisible })
  }

  handleFetchLmExpress(values) {
    const { fetchLmExpress, auth } = this.props

    this.setState({ controlView: true })

    fetchLmExpress(auth, values)
  }

  renderError(message) {
    const { translate } = this.props

    /* istanbul ignore else */
    if (message.dsMessage) {
      const text = translate('form.data.invalid')

      return (
        <FeedbackError
          className='margin-top-double'
          message={message.dsMessage}
          text={text}
        />
      )
    }
  }

  render() {
    const { translate, error, lmExpress, filters, auth } = this.props

    const { filtersVisible, lmExpressInfoVisible } = this.state

    return (
      <section>
        <ContentHeader>{translate('mobile.olderLmExpress')}</ContentHeader>

        <LmExpressHeader
          translate={translate}
          pageName={translate('mobile.olderLmExpress')}
        />

        {error && !filtersVisible && this.renderError(error.message)}

        {filtersVisible && (
          <PeriodPickerLmExpress
            translate={translate}
            fetchLmExpress={this.handleFetchLmExpress}
            auth={auth}
          />
        )}

        {lmExpressInfoVisible && (
          <LmExpress
            translate={translate}
            lmExpress={lmExpress}
            getCsv={this.getCsv}
            filters={filters}
          />
        )}
      </section>
    )
  }
}

/*
 * Maps redux state to component props
 */
/* istanbul ignore next */
const mapStateToProps = ({ lmExpressReducer, reportReducer }) =>
  /* istanbul ignore next */
  ({
    lmExpress: lmExpressReducer.record,
    error: lmExpressReducer.error,
    filters: lmExpressReducer.filters,
    report: reportReducer.get.record,
  })

/*
 * Maps actions and dispatch them to component props
 */
/* istanbul ignore next */
const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...lmExpressActions, ...reportActions }, dispatch)

/*
 * Connects component to I18next
 */
/* istanbul ignore next */
const LmExpressTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(OlderLmExpressContainer)

/*
 * Exports component connected to redux as default
 */
/* istanbul ignore next */
export default connect(mapStateToProps, mapDispatchToProps)(LmExpressTranslated)

export { OlderLmExpressContainer }
